export default "__VITE_ASSET__DvgQBSCi__"